import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "./types";
import { globalSearch } from "./GlobalSearch";
import { serviceSchedule } from "./ServiceSchedule";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {
    globalSearch,
    serviceSchedule,
  },
};

export default new Vuex.Store<RootState>(store);
